import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c(VTextField,{attrs:{"label":_vm.label,"variant":_vm.variant,"type":_vm.type,"hint":_vm.hint,"readonly":_vm.readonly,"disabled":_vm.disabled,"placeholder":_vm.placeholder,"prepend-inner-icon":_vm.prependIcon,"append-inner-icon":_vm.appendIcon,"suffix":_vm.suffix,"prefix":_vm.prefix,"value":_vm.defaultValue,"dark":_vm.dark},on:{"change":_vm.getVal}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }